import { AxiosInstance } from 'axios'

import { AxiosErrorHandler } from '../../foundation'
import {
  BenefitDetailView,
  CreateBenefitApiCommand,
  EditBenefitApiCommand,
  EditBenefitOrderApiCommand,
  GetBenefitsListApiQuery,
  PaginationResultBenefitListView,
} from '../../contracts/review/AdminApiBenefit'

export class AdminApiBenefit {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getBenefitList = async (criteria: GetBenefitsListApiQuery): Promise<PaginationResultBenefitListView> => {
    const config = {
      url: '/review/query/admin/get-benefits-list/process',
      method: 'post',
      data: criteria,
    }

    try {
      const { data } = await this.axios.request<PaginationResultBenefitListView>(config)

      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getBenefitDetail = async (id: number): Promise<BenefitDetailView> => {
    const config = {
      url: '/review/query/admin/get-benefit-detail/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<BenefitDetailView>(config)

      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  createBenefit = async (criteria: CreateBenefitApiCommand): Promise<void> => {
    const config = {
      url: '/review/command/admin/create-benefit/execute',
      method: 'post',
      data: criteria,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  editBenefit = async (criteria: EditBenefitApiCommand): Promise<void> => {
    const config = {
      url: '/review/command/admin/edit-benefit/execute',
      method: 'post',
      data: criteria,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  deleteBenefit = async (id: number): Promise<void> => {
    const config = {
      url: '/review/command/admin/delete-benefit/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  editBenefitOrder = async (criteria: EditBenefitOrderApiCommand): Promise<void> => {
    const config = {
      url: '/review/command/admin/edit-benefit-order/execute',
      method: 'post',
      data: criteria,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
